"use client";
import Link from "next/link";
import React, { Suspense, useState } from "react";
import { SlArrowDown } from "react-icons/sl";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import DropdownItems from "./DropdownItems";

interface DropdownMenuProps {
  option: string;
  availableFilters: string[];
  className?: string;
  pathname?: string;
  dropdownName?: string;
  typeOfDropdown: TypeDropdown;
  children?: React.ReactNode;
}

const Dropdown = ({
  availableFilters,
  option,
  className,
  pathname,
  dropdownName,
  typeOfDropdown,
  children,
}: DropdownMenuProps) => {
  const [isActive, setIsActive] = useState(false);

  const onMouseEnter = () => {
    if (window.innerWidth > 885) {
      setIsActive(true);
    }
  };

  const onMouseLeave = () => {
    if (window.innerWidth > 885) {
      setIsActive(false);
    }
  };

  return (
    <li
      className={`list-element dropdown-menu-pc ${className ? className : ""}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <span
        className={`${pathname === `/${option}` ? `navlink-active-desktop` : ""}`}
      >
        <Link href={`/${option}`} className="dropdown-trigger">
          {dropdownName ? dropdownName : option}
          <SlArrowDown size={12} />
        </Link>
      </span>
      {availableFilters.length > 0 && (
        <ul className={`dropdown-options ${isActive ? "active" : ""}`}>
          <Suspense fallback={<Skeleton width={200} height={20} />}>
            <DropdownItems
              availableFilters={availableFilters}
              setIsActive={setIsActive}
              typeOfDropdown={typeOfDropdown}
              option={option}
            />
            {children}
          </Suspense>
        </ul>
      )}
    </li>
  );
};

export default Dropdown;
